/**
 * Different tools use these version references to target specific builds.
 */
export const ALL_SUPPORTED_BROWSERS = [
  'last 3 Chrome versions',
  'last 3 Firefox versions',
  'last 3 Safari versions',
  'last 3 Edge versions',
  'ie 11',
]

export const MODERN_BROWSERS = [
  'last 1 Chrome versions',
  'last 1 Firefox versions',
  'last 1 Safari versions',
  'last 1 Edge versions',
]

